module.exports = __webpack_public_path__ + "bdb186c6626b3ea488eb27346f90e16d.png";